import {
    createCatalogService,
} from "~/services";

export default defineNuxtPlugin(() => {
    return {
        provide: {
            catalogService: createCatalogService(),
        }
    }
})